import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import {
    JiraOverlayTemplate,
    LayoutVersion
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { useUserContext } from "@/components/user-context";
import { wacToken } from "@/libraries/design/foundations";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { WelcomeBackHeading } from "../../components";

export const LoggedInJiraFreeExistingSitesUser = () => {
    const {
        user: { name }
    } = useUserContext();

    const version = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    )
        ? LayoutVersion.V2
        : LayoutVersion.V1;

    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm" version={version}>
                <div css={containerCss}>
                    <h1 css={headerCss}>
                        <WelcomeBackHeading name={name} />
                    </h1>
                    <p css={subHeaderCss}>
                        <FormattedMessage
                            id="signupForm.accountCreation.subHeaderText"
                            defaultMessage="It’s free for up to 10 users - no credit card needed."
                        />
                    </p>
                    <SiteActivation />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const subHeaderCss = css({
    margin: "0 auto",
    color: wacToken("color.primary.black"),
    textAlign: "center"
});
